export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-squidoo-ef771f96586b66810a731e6726b5747f.svg";